
import React from 'react';
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
} from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ReplayIcon from '@mui/icons-material/Replay';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

interface BottomNavbarProps {
  activeTab: 'home' | 'cart' | 'buy-again' | 'your-orders';
  onTabChange: (tab: 'home' | 'cart' | 'buy-again' | 'your-orders') => void;
}

const BottomNavbar: React.FC<BottomNavbarProps> = ({ activeTab, onTabChange }) => {
  const tabIndexMap = {
    home: 0,
    cart: 1,
    'buy-again': 2,
    'your-orders': 3,
  };

  const indexTabMap = ['home', 'cart', 'buy-again', 'your-orders'];

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    const newTab = indexTabMap[newValue];
    onTabChange(newTab as BottomNavbarProps['activeTab']);
  };

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
      }}
      elevation={3}
    >
    <BottomNavigation
      value={tabIndexMap[activeTab]}
      onChange={handleChange}
      showLabels
      sx={{
        height: 60, 
        '& .MuiBottomNavigationAction-root': {
          paddingTop: '6px',
          paddingBottom: '6px',
        },
        '& .MuiBottomNavigationAction-iconOnly': {
          paddingTop: '6px',
        },
        '& .MuiSvgIcon-root': {
          fontSize: '1.5rem',
        },
        '& .Mui-selected .MuiSvgIcon-root': {
          fontSize: '1.5rem',
        },
        '& .MuiBottomNavigationAction-label': {
          // responsive font size
          fontSize: {
            xs: '0.65rem',  
            sm: '0.7rem',  
            md: '0.9rem', 
            lg: '1rem',   
          },
          transition: 'none',
        },
        '& .Mui-selected .MuiBottomNavigationAction-label': {
          fontWeight: 'normal',
          fontSize: {
            xs: '0.65rem',  
            sm: '0.7rem',  
            md: '0.9rem', 
            lg: '1rem',   
          },
        },
      }}
    >
        <BottomNavigationAction label="Home" icon={<HomeIcon />} />
        <BottomNavigationAction label="Cart" icon={<ShoppingCartIcon />} />
        <BottomNavigationAction label="Buy Again" icon={<ReplayIcon />} />
        <BottomNavigationAction label="Your Orders" icon={<ReceiptLongIcon />} />
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNavbar;
